import * as React from 'react';
import './_constant/globalVariables';
import './_fn/debug';
import { THEME_LIGHT } from './_style';
import { BrowserRouter } from 'react-router-dom';
import store from './_stores';
import { Provider } from 'react-redux';
import { Frame } from './Frame';
import { CssBaseline, ThemeProvider, createTheme } from '@mui/material';
import ReactGA4 from 'react-ga4';

const ColorModeContext = React.createContext({ toggleColorMode: () => {} });
const GACode = {
  mkd: 'G-3BC6JFB75R', // 行銷
  itd: 'G-YB320NJL2Y', // 原始
};

export default function App() {
  // 初始化 GA4
  ReactGA4.initialize([{ trackingId: GACode.mkd }, { trackingId: GACode.itd }]);

  const [mode, setMode] = React.useState('light');

  const colorMode = React.useMemo(
    () => ({
      toggleColorMode: () => {
        setMode((prevMode) => (prevMode === 'light' ? 'dark' : 'light'));
      },
    }),
    [],
  );

  const theme = React.useMemo(
    () =>
      createTheme({
        ...THEME_LIGHT,
      }),
    [],
  );

  React.useEffect(() => {
    if (localStorage.darkMode) {
      setMode(localStorage.darkMode);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Provider store={store}>
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <ColorModeContext.Provider value={colorMode}>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <Frame ColorModeContext={ColorModeContext} />
          </ThemeProvider>
        </ColorModeContext.Provider>
      </BrowserRouter>
    </Provider>
  );
}
